/* import __COLOCATED_TEMPLATE__ from './avatars.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();